import Modal from '../custom/Modal';
import ModalClose from './ModalClose';
import { useDispatch, useSelector } from 'react-redux';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';

const ReportInfoModal = () => {
	const dispatch = useDispatch();
	const modalTitle = useSelector((state: any) => state.ui.modalTitle);

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.REPORT_INFO_MODAL));
	};

	return (
		<Modal onClose={handleOnCloseModal} ariaLabel={modalTitle}>
			<ModalClose onClose={handleOnCloseModal} />
			<div className="modal-title">
				<h2>{modalTitle}</h2>
			</div>
			<div>
				Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
				labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et
				ea rebum.
			</div>
		</Modal>
	);
};

export default ReportInfoModal;
